import { getConfiguredCountries } from "../../../lib/ProgramTheme/programThemeGetters";
import { type Country, type ProgramTheme } from "../../../lib/types/types";

/**
 * Returns true if there is a country picker on the form and the user has _not_ selected a country yet
 *
 * Returns false if there is only 1 country configured for the program (and thus no country picker on the form)
 *  _or_ if a user has selected a country
 */
export const isCountrySelectionNeeded = (
  programTheme: ProgramTheme,
  country: Country = undefined,
) => (getConfiguredCountries(programTheme) || []).length >= 2 && !country;
